import {IAppRoute} from "../../application/config/IAppRoute";
import {routeWrongWayResolutionCreateZipTestPage} from "./routeWrongWayResolutionCreateZipTestPage";

export const routesWrongWayResolution: IAppRoute<any>[] = [
  routeWrongWayResolutionCreateZipTestPage,
];
